import React from "react";
import { Link as RouterLink } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import bcConfig from "../utils/breadcrumbs";
import useBreadcrumbsFromConfig from "../hooks/useBreadcrumbsFromConfig";

const BaseBreadcrumbs = () => {
    const items = useBreadcrumbsFromConfig(bcConfig);

    if (!items.length) {
        return null;
    }

    return (
        <div className="flex items-center gap-2 text-sm">
            <Breadcrumbs
                separator="/"
                aria-label="breadcrumb"
                classes={{ separator: "text-slate-400" }}
                className="flex items-center gap-2"
            >
                {items.map((it) =>
                    it.isCurrent ? (
                        <span
                            key={it.path}
                            className="text-slate-200 text-sm font-semibold"
                        >
                            {it.label}
                        </span>
                    ) : (
                        <RouterLink
                            key={it.path}
                            to={it.path}
                            className="hover:text-slate-200 text-sm text-slate-400"
                        >
                            {it.label}
                        </RouterLink>
                    )
                )}
            </Breadcrumbs>
        </div>
    );
};

export default BaseBreadcrumbs;
